import React, { useEffect, useState } from "react";
import CustomTable from "../../../../components/common/CustomTable";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import { useDispatch } from "react-redux";
import CustomModal from "../../../../components/common/Modal";
import { useFormik } from "formik";
import {
   addContactDetails,
   editContactDetailsAsync,
   fetchSingleContractorMasterAsync,
} from "../../../../redux/features/contractorMasterSlice";
import toast from "react-hot-toast";
import * as Yup from "yup";
import validation from "../../../../helpers/validation";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import { BsPencilSquare } from "react-icons/bs";

const validationSchema = Yup.object().shape({
   name: validation.name("Contact Person Name"),
   mobile: validation.mobile,
   email: validation.email,
});

const ContactDetails = ({ data, id }) => {
   const dispatch = useDispatch();

   const [records, setRecords] = useState(data ?? []);
   const [isOpen, setIsOpen] = useState(false);
   //  const [checked, setIsChecked] = useState(false);
   const [action, setAction] = useState("");

   useEffect(() => {
      if (data) {
         setRecords(data);
      }
   }, [data]);

   const formik = useFormik({
      initialValues: {
         id: "",
         mobile: "",
         name: "",
         email: "",
      },
      validationSchema,
      onSubmit: (values) => {
         if (action === "add") {
            return handleAddNew(values);
         } else if (action === "edit") {
            return handleContactUpdate(values);
         }
      },
   });

   const { errors, touched, getFieldProps, handleSubmit, resetForm, setValues } = formik;

   //Handle Close modal
   const handleClodeModal = () => {
      setIsOpen(false);
      resetForm();
   };

   //Handle Edit Button
   const handleEditButton = (item) => {
      setAction("edit");
      setIsOpen(true);
      setValues({
         id: item.id,
         mobile: item?.mobile,
         name: item?.name,
         email: item?.email,
      });
   };

   // Handle Add Button
   const handleAddButton = () => {
      setAction("add");
      setIsOpen(true);
   };

   const columns = [
      {
         name: "Contact Person Name",
         selector: (row) => row.name,
         sortable: true,
      },
      {
         name: "Mobile Number",
         selector: (row) => {
            return row.mobile;
         },
      },
      {
         name: "Email Id",
         selector: (row) => row.email,
      },
      {
         name: "Action",
         selector: (row) => {
            return (
               <button className="btn mx-2" onClick={() => handleEditButton(row)}>
                  <BsPencilSquare
                     className="text-primary"
                     style={{ height: "1.5rem", width: "1.5rem" }}
                  />
               </button>
            );
         },
         width: "6rem",
      },
   ];

   // Hanlde add new
   const handleAddNew = async (formValue) => {
      dispatch(backdropLoadingAction(true));

      const newData = new FormData();
      newData.append("contractor_master_id", id);
      newData.append("contact_person_name[]", [formValue.name]);
      newData.append("mobile[]", [formValue.mobile]);
      newData.append("email[]", [formValue.email]);

      newData.append("child_type", "contact_person");

      newData.append("model_id", 9);
      newData.append("action_id", 2);

      dispatch(
         addContactDetails({
            data: newData,
            done: () => {
               toast.success("Updated successfully");
               dispatch(backdropLoadingAction(false));

               handleClodeModal();
               dispatch(
                  fetchSingleContractorMasterAsync({
                     id: id,
                  })
               );
            },
            err: (error) => {
               toast.error(error);
               dispatch(backdropLoadingAction(false));
            },
         })
      );
   };

   // Handle update
   const handleContactUpdate = async (formValue) => {
      dispatch(backdropLoadingAction(true));
      const updatedata = new FormData();

      updatedata.append("contractor_master_id", id);
      updatedata.append("contact_person_details_id", formValue?.id);
      updatedata.append("contact_person_name[]", [formValue?.name]);
      updatedata.append("mobile[]", [formValue?.mobile]);
      updatedata.append("email[]", [formValue?.email]);

      updatedata.append("model_id", 9);
      updatedata.append("action_id", 2);
      updatedata.append("_method", "PATCH");

      dispatch(
         editContactDetailsAsync({
            data: updatedata,
            done: () => {
               toast.success("Updated successfully");
               dispatch(backdropLoadingAction(false));
               handleClodeModal();
               dispatch(
                  fetchSingleContractorMasterAsync({
                     id: id,
                  })
               );
            },
            err: (error) => {
               toast.error(error);
               dispatch(backdropLoadingAction(false));
            },
         })
      );
   };

   return (
      <>
         <div className="row justify-content-end">
            <div className="d-flex justify-content-end pb-1">
               <button className="btn btn-primary" onClick={handleAddButton}>
                  Add Contact
               </button>
            </div>
            <CustomTable columns={columns} data={records} />
         </div>
         <CustomModal
            title={`${action === "edit" ? "Edit" : "Add"} Contact Details`}
            showModal={isOpen}
            handleCloseModal={handleClodeModal}
            onSubmit={handleSubmit}
            modalSize="modal-md"
            child={
               <div>
                  <CustomInput
                     require
                     label="Contact Person Name"
                     inputType="text"
                     id="#contact_person_name"
                     placeholder="Enter Contact Person Name."
                     {...getFieldProps("name")}
                     errors={touched?.name && errors?.name}
                     message={errors?.name}
                  />

                  <CustomInput
                     require
                     label="Mobile No"
                     inputType="text"
                     id="#mobile"
                     name="mobile"
                     {...getFieldProps("mobile")}
                     placeholder="Enter Contact Person Mobile No."
                     errors={touched?.mobile && errors?.mobile}
                     message={errors?.mobile}
                  />

                  <CustomInput
                     require
                     label="Email Id"
                     inputType="text"
                     id="#email"
                     name="email"
                     {...getFieldProps("email")}
                     placeholder="Enter Contact Person Email"
                     errors={touched?.email && errors?.email}
                     message={errors?.email}
                  />
               </div>
            }
         />
      </>
   );
};

export default ContactDetails;
